import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import TextField from 'components/forms/textField/TextField';
import Button from 'components/button/Button';
import useUnitManagement from '../useUnitManagement';
import { UnitListSchemaType } from '../PropertySettingsUnitsTab.schema';
import { AddExtraUnitsContainer } from './UnitList.styles';

export const AddExtraUnits = () => {
  const { t } = useTranslation();
  const extraUnitsCount = useWatch({ name: 'extraUnits' });
  const { addUnits } = useUnitManagement();
  const { setValue } = useFormContext<UnitListSchemaType>();

  const handleAddUnits = () => {
    addUnits(extraUnitsCount);
    setValue('extraUnits', 1);
  };

  return (
    <AddExtraUnitsContainer>
      <span>{t('pageProperty.units.addExtraUnits')}</span>
      <TextField
        colXsInput={12}
        min={1}
        max={100}
        type="number"
        name="extraUnits"
        rightAddons={[t('pageProperty.units.units')]}
      />
      <Button data-testid="add-extra-units-button" onClick={handleAddUnits}>
        {t('common.add')}
      </Button>
    </AddExtraUnitsContainer>
  );
};
